<template>
  <div>
    <!-- Start Header Area -->
    <div class="navbar-area fixed-top">
      <div class="huruma-responsive-nav">
        <div class="container">
          <div class="huruma-responsive-menu">
            <div class="logo">
              <a href="/">
                <img
                  src="assets/img/clc_logo2.jpeg"
                  width="40%"
                  class="white-logo"
                  alt="logo"
                />
                <img
                  src="assets/img/clc_logo1.jpeg"
                  width="40%"
                  class="black-logo"
                  alt="logo"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="navbar-area fixed-top">
        <div class="huruma-nav">
          <div class="container">
            <nav class="navbar navbar-expand-md navbar-light">
              <a class="navbar-brand" href="/">
                <img
                  src="assets/img/clc_logo2.jpeg"
                  width="90px"
                  class="white-logo"
                  alt="logo"
                />
                <img
                  src="assets/img/clc_logo1.jpeg"
                  width="90px"
                  class="black-logo"
                  alt="logo"
                />
              </a>

              <div
                class="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
              >
                <ul class="navbar-nav">
                  <li class="nav-item">
                    <a href="/" class="nav-link">Home</a>
                  </li>

                  <li class="nav-item">
                    <a href="#" class="nav-link">
                      Programs
                      <i class="bx bx-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a href="/ipdyi" class="nav-link">IPDYI</a>
                      </li>
                      <li class="nav-item">
                        <a href="/rhema-prophetic-centre" class="nav-link"
                          >Rhema Prophetic Centre</a
                        >
                      </li>

                      <li class="nav-item">
                        <a
                          href="/business-leadership-institute"
                          class="nav-link"
                          >Business and Leadership Institute</a
                        >
                      </li>

                      <li class="nav-item">
                        <a href="/trauma-healing-centre" class="nav-link"
                          >Trauma Healing Centre</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <a href="/gallery" class="nav-link">Gallery</a>
                  </li>

                  <li class="nav-item">
                    <a href="#" class="nav-link">
                      About
                      <i class="bx bx-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu">
                      <li class="nav-item">
                        <a
                          href="#"
                          class="nav-link"
                          data-toggle="modal"
                          data-target="#backgroundModal"
                          >Background</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          href="#"
                          class="nav-link"
                          data-toggle="modal"
                          data-target="#rationaleModal"
                          >Rationale</a
                        >
                      </li>
                      <li class="nav-item">
                        <a
                          href="#"
                          class="nav-link"
                          data-toggle="modal"
                          data-target="#historyModal"
                          >History</a
                        >
                      </li>
                      <li class="nav-item">
                        <a href="/clc-team" class="nav-link">Team</a>
                      </li>
                      <li class="nav-item">
                        <a
                          target="_blank"
                          href="https://drive.google.com/drive/u/0/folders/0B7vFk0DueDXCTTdoU25TYlNoLVk"
                          class="nav-link"
                          >Available resource</a
                        >
                      </li>
                    </ul>
                  </li>

                  <li class="nav-item">
                    <a href="/contact" class="nav-link">Contact Us</a>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="nav-link"
                      :to="{
                        name: 'Register',
                        params: {
                          src
                        }
                      }"
                      >Join Us</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <form action="https://www.paypal.com/donate" method="post" target="_top">
<input type="hidden" name="business" value="URRMDKKM98NNN" />
<input type="hidden" name="item_name" value="City Life Centre" />
<input type="hidden" name="currency_code" value="USD" />
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
<img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
</form>


                  </li>
                </ul>
              </div>
              <div class="others-options">
                <div class="burger-menu">
                  <i class="flaticon-menu"></i>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Modal -->
    <div class="modal fade" id="backgroundModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Background</h4>
            <p>
              The city life centre (CLC) seeks to provide for the society, in
              one complex, requisite environment that enables participating
              member to acquire characteristics which make for patriotism,
              nation building and peaceful coexistence. The centre adopts both
              formal and informal training methods. CLC, Botswana in Gaborone
              (like all other CLCs worldwide) is a relational, community-based
              Christian organisation that aims to holistically develop and
              nurture young people to become Christian leaders within the church
              and at the market place of life.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="rationaleModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>Rationale for CLC</h4>
            <p>
              The contemporary society presents a convergence of communities
              having social, cultural, economic and spiritual disconnect from
              one another. These communities and their ideologies compete for
              the attention and control of the Christian. Insisting on a life
              guided by the principles of the word of God has become obsolete,
              and in most cases, a source of persecution. How does the Christian
              cope with the changing times without compromising his faith in
              God? The Christian must be able to peel off these layers of world
              view that try to overshadow the word of God and reach for the pure
              word of God. These characteristics of steadfastness and purity
              despite persecution and temptations must be learned. The city life
              centre, Botswana addresses these challenges through offering a
              holistic gospel which serves to meet the all-round (spiritual,
              emotional, psychological, social, financial) needs of the
              individual. We promote justice, empower young people to cultivate
              lifelong discipleship and become change agents in their society.
              Through the programs of the rhema prophetic centre (RPC) that
              provides spiritual mentorship, every participant finds true
              spiritual restoration and discipleship that they need to mature
              into effective Christian and nation builder. The trauma healing
              centre (THC) with its programs has been designed to cater for
              (mental) psychological and emotional wellbeing of participants.
              All taught modules, internship and externship programs of the
              business and leadership institute (BLI) and the international
              purpose driven youth initiatives (IPDYI) help participants
              discover their person, purpose and potentials. Through efficient
              networking and apprenticeship programs participants develop from
              dependents to self-reliant individuals who in turn deploy their
              giftings for advancement of their society and achievement of the
              entire purpose of humanity on earth.
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="historyModal" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title"></h4>
          </div>
          <div class="modal-body">
            <h4>History</h4>
            <p>
              The pioneers of CLC are Christians who realized a subtle but
              progressive decay in church. The modern-day church appeared to be
              unaware of the original purpose of her existence. Emphasis has
              shifted from Jesus Christ; his person, plans and purposes for
              mankind to observance of mere religious rituals and traditions.
              Christian religious leaders have customized certain aspects the
              faith to suit their self-seeking quest; “…heaping to themselves
              teachers after their own lust, having itching ears. They have
              turned away their ears from the truth…” (2 Timothy 4:3). Certain
              preachers have glorified themselves into “deputy Holy Spirit”.
              They emphasize the gifts and move of God more than the person of
              God. Following salvation, the pastor’s job is to grow the young
              converts into mature disciple. However, discipleship is missing in
              many Christian groups. Unknown to the church, many persons develop
              deep seated emotional and psychological wounds before salvation.
              If there is no thorough healing and restoration of wholeness, the
              new believer continues to struggle with these hidden wounds and
              brokenness. Unfortunately, because these wounds are not visible to
              the naked eye, they are ignored. But these wounds prevent the word
              from penetrating into the soul of the believer to produce expected
              fruits of righteousness. Dr. Goodhead and his team observed that
              many Christians in their city of Gaborone, and beyond, struggled
              with dirty habits, unresolved wounds and character deficiencies
              that were inimical to their faith. He also observed that many
              church groups did not emphasis the holistic word of God and so
              produced dysfunctional Christians. During this time, himself and
              his team had been running a prayer and prophetic meeting. But upon
              realizing how shallow and self-seeking their member and most
              Christians in churches were, the team decided to invest more in
              Bible study meetings than in performing miracles and prophesying.
              The team developed listening sessions, practical discussion
              groups, counselling units through one-to-one meetings, practical
              Christian mentorship programs, etc. Gradually, testimonies in
              their meetings moved away from material favors to miracles of
              genuine salvation of souls, deepening of personal fellowship with
              the spirit of God, change of lifestyles, deliverance from dirty
              habits which were replaced with new characters of Christ etc. With
              time the team evolved a centre that provides her members more than
              a pulpit preaching but a real life one-to-one holistic Christian
              mentorship program. That is the birth of CLC
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar Modal -->
    <div class="sidebar-modal">
      <div class="sidebar-modal-inner">
        <div class="sidebar-about-area">
          <div class="title">
            <h2>The society’s Mission</h2>
            <p>
              “To Raise motivated men and women of faith who will bear positive
              impact on the nation and the world at large.”
            </p>

            <h2>The societies purpose</h2>
            <p>
              Seeks to provide for the society, in one complex, requisite
              environment that shall enable the individual acquire
              characteristics that will make for patriotism, nation building and
              peaceful coexistence through training on Christian values The
              Centre shall adopt Case Method Training (both formal and Informal)
            </p>

            <h2>The society’s vision</h2>
            <p>
              To become a leading organization in Botswana & SADC by raising a
              generation of people dedicated to community service through
              spiritual development, educational opportunities, economic
              empowerment & faith-based outreach
            </p>
          </div>
        </div>

        <div class="sidebar-instagram-feed">
          <a href="#">
            Download our Constitution
            <i class="bx bxs-download"></i>
          </a>
        </div>

        <div class="sidebar-contact-area">
          <div class="contact-info">
            <div class="contact-info-content">
              <h2>
                <a href="tel:+26774103043">+26774103043</a>
                <span>OR</span>
                <a href="mailto:admin@clcentre.org">admin@clcentre.org</a>
              </h2>

              <ul class="social">
                <li>
                  <a href="#" target="_blank">
                    <i class="flaticon-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i class="flaticon-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i class="flaticon-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i class="flaticon-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i class="flaticon-pinterest"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <span class="close-btn sidebar-modal-close-btn">
          <i class="flaticon-close"></i>
        </span>
      </div>
    </div>
    <!-- End Sidebar Modal -->
  </div>
</template>

<script>
export default {
  name: "Navigation",
  data() {
    return {
      src:
        "https://docs.google.com/forms/d/e/1FAIpQLSfop-mfMYBGLX39K5QH4r7s44PTggw2nG0SQ_yHQfhSCt1F9g/viewform?embedded=true"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
